import {
    CONFIRMED_GET_LISTING_TYPES
} from '../actions/ListingType/ListingTypeTypes';
const initialState = {
    lisitngTypes: [],
    loading: false,
};

function ListingTypesReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_LISTING_TYPES_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_LISTING_TYPES:
            return {
                ...state,
                lisitngTypes: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {ListingTypesReducer};